import { render, staticRenderFns } from "./SwipeActions.vue?vue&type=template&id=61080cfa&scoped=true&"
import script from "./SwipeActions.vue?vue&type=script&lang=ts&"
export * from "./SwipeActions.vue?vue&type=script&lang=ts&"
import style0 from "./SwipeActions.vue?vue&type=style&index=0&id=61080cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61080cfa",
  null
  
)

export default component.exports